import styles from "./profile.module.css";
import { FaPlusCircle } from "react-icons/fa";
import ax from "assets/images/img525.svg";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { MdAddCircleOutline } from "react-icons/md";
import { MdRemoveCircleOutline } from "react-icons/md";
import CustomerManagement from "components/customer-management/CustomerManagement";
import "./sty.css";
import { useParams } from "react-router-dom";
import { connection } from "utils/apiConnection.ts";
import Loader from "utils/Loader";
import toast, { Toaster } from "react-hot-toast";
const Profile = ({ updater, setUpdater, match }) => {
  let { shop_suffix } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [editDisable, setEditDisable] = useState([{ status: true }]);
  const [SelectedUserInformation, setSelectedUserInformation] = useState({
    shopId: 0,
    num: "",
    num2: "",
    title: " ",
    urlPage: "",
    about: "",
    tags: [],
    address: "",
    cover: null,
    logoShop: null,
    coverId: 0,
    logoShopId: 0,
    socialMedia: [
      { nameField: "", selectField: "-1" },
      { nameField: "", selectField: "-1" },
    ],
  });

  let x = {
    socialMedia: [
      { nameField: "", selectField: "-1" },
      { nameField: "", selectField: "-1" },
    ],
  };
  async function changeHandlerImg(e) {
    let name = e.target.name;
    let result = await connection("uploadfiles", {
      "files[]": e.target.files[0],
    });
    setSelectedUserInformation((prev) => {
      return {
        ...prev,
        [name + "Id"]: result.result[0].id,
        [name]: result.result[0].path,
      };
    });
  }

  // const changeHandlerImg = (e) => {
  //   let myFormData = new FormData();
  //   myFormData.append("files[]", e.target.files[0]);
  //   setSelectedUserInformation({
  //     ...SelectedUserInformation,
  //     [e.target.name]: e.target.files[0],
  //   });
  //   console.log(SelectedUserInformation);
  //   axios
  //     .post("http://tatclub.tatdemo.ir/api/uploadfiles", myFormData)
  //     .then(({ data }) => {
  //       setSelectedUserInformation((prev) => {
  //         return { ...prev, [e.target.name + "Id"]: data.result[0].id };
  //       });
  //     })
  //     .catch((err) => console.log(err));
  // };
  const changeHandlerLogo = (e) => {
    let myFormData = new FormData();
    myFormData.append("files[]", SelectedUserInformation.logoShop);
    axios
      .post("http://tatclub.tatdemo.ir/api/uploadfiles", myFormData)
      .then((res) => {
        setSelectedUserInformation({
          ...SelectedUserInformation,
          [e.target.name]: e.target.files[0],
        });
      })
      .catch((err) => console.log(err));
  };

  const handleChangeInput = (index, event) => {
    const values = [...SelectedUserInformation.socialMedia];
    values[index][event.target.name] = event.target.value;
    setSelectedUserInformation({
      ...SelectedUserInformation,
      socialMedia: values,
    });
  };
  const handleAddFields = () => {
    setSelectedUserInformation((pervState) => {
      pervState.socialMedia = [
        ...pervState.socialMedia,
        { nameField: "", selectField: "-1" },
      ];
      return { ...pervState };
    });
  };
  const handleRemoveFields = (index) => {
    const values = [...SelectedUserInformation.socialMedia];
    values.splice(index, 1);

    setSelectedUserInformation({
      ...SelectedUserInformation,
      socialMedia: values,
    });
  };
  const inputRef = useRef();

  useEffect(() => {
    async function loadPage() {
      let id = shop_suffix;
      let result = await connection("getshopinfo", {
        shopSuffix: `${id}`,
      });
      console.log("resa", result.result.id);
      setSelectedUserInformation({
        shopId: result.result.id,
        num: result.result.tell,
        num2: result.result.mobile,
        title: result.result.title,
        urlPage: result.result.shop_suffix,
        about: result.result.about_us,
        address: result.result.address_text,
        logoShopId: result.result.logo_img_id,
        coverId: result.result.cover_img_id,
        logoShop: result.result.logoAddress,
        socialMedia: [
          {
            nameField: JSON.parse(result.result.other_params).socialMedia[0]
              .nameField,
            selectField: JSON.parse(result.result.other_params).socialMedia[0]
              .selectField,
          },
          {
            nameField: JSON.parse(result.result.other_params).socialMedia[1]
              .nameField,
            selectField: JSON.parse(result.result.other_params).socialMedia[1]
              .selectField,
          },
        ],
      });
    }
    loadPage();
  }, []);

  async function updateHandler(SelectedUserInformation) {
    let id = SelectedUserInformation.shopId;
    let x = { socialMedia: SelectedUserInformation.socialMedia };
    // setIsLoading(true);
    let result = await connection("editshop", {
      shopId: `${id}`,
      tell: SelectedUserInformation.num2,
      mobile: SelectedUserInformation.num,
      title: SelectedUserInformation.title,
      shopSuffix: SelectedUserInformation.urlPage,
      aboutUs: SelectedUserInformation.about,
      addressText: SelectedUserInformation.address,
      coverImgId: SelectedUserInformation.coverId,
      logoImgId: SelectedUserInformation.logoShopId,
      otherParams: JSON.stringify(x),
    });
    console.log("result.res", result.status);
    if (result.status == -1) {
      toast.error("خطا در اعمال تغییرات!");
    } else {
      toast.success("تغییرات با موفقیت اعمال شد");
    }
    setEditDisable((prevState) => {
      return [...prevState, (editDisable[0].status = !editDisable[0].status)];
    });
    // setIsLoading(false);
    // toast.success("تغییرات با موفقیت ثبت شد!");
  }

  const editHandler = () => {
    setEditDisable((prevState) => {
      return [...prevState, (editDisable[0].status = !editDisable[0].status)];
    });
  };

  return (
    <div className="container m-auto my-5">
      <div
        className={`d-flex justify-content-around flex-wrap pb-5 ${styles.bgGray}`}
      >
        <div
          className="edit-user-item d-flex justify-content-center w-100"
          style={{ marginTop: "-35px" }}
        >
          <label htmlFor="profile-pic">
            <div className="profile-pic position-relative">
              <input
                disabled={editDisable[0].status}
                className="d-none"
                type="file"
                accept="image/*"
                id="ProfilePic"
                ref={inputRef}
                name="logoShop"
                onChange={changeHandlerImg}
              />
              <img
                src={
                  SelectedUserInformation.logoShop === ""
                    ? `${ax}`
                    : `${SelectedUserInformation.logoShop}`
                }
                alt=""
                style={{
                  width: "80px",
                  borderRadius: "50%",
                  height: "80px",
                  overflow: "hidden",
                }}
              />
              <label
                htmlFor="ProfilePic"
                className="position-absolute text-dark"
                style={{ right: "3px", top: "-10px", cursor: "pointer" }}
              >
                <FaPlusCircle />
              </label>
            </div>
          </label>
        </div>
        <div className="w-100">
          <div
            className={` d-flex justify-content-around  ${styles.CryptoTabsContainer}`}
          >
            <ul class="nav nav-pills mt-4">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home"
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  پروفایل
                </button>
              </li>

              <li class="nav-item">
                <button
                  class="nav-link "
                  id="contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#contact"
                  type="button"
                  role="tab"
                  aria-controls="contact"
                  aria-selected="true"
                >
                  مدیریت کاربران
                </button>
              </li>
            </ul>
          </div>
          <div class="tab-content w-100" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className=" w-100 mt-2 ">
                {/* {isLoading && <Loader></Loader>} */}
                <div className="container">
                  <div className="row">
                    <div
                      className={` col-lg-6 col-xs-12    text-center  ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}>عنوان فروشگاه</p>
                        <input
                          className={styles.inpu}
                          type="text"
                          disabled={editDisable[0].status}
                          value={SelectedUserInformation.title}
                          onChange={(e) =>
                            setSelectedUserInformation({
                              ...SelectedUserInformation,
                              [e.target.name]: e.target.value,
                            })
                          }
                          name="title"
                        />
                      </div>
                    </div>
                    <div
                      className={` col-lg-6 col-xs-12    text-center  ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}>آدرس صفحه</p>
                        <div class={`input-group  ${styles.inpu} `} dir="ltr">
                          <div
                            class="input-group-prepend bg-white"
                            style={{ borderRadius: "20px" }}
                          >
                            <span
                              class="input-group-text"
                              id="basic-addon3"
                              style={{
                                borderRadius: "10px 0px 0px 10px",
                                height: "70px",
                                borderRight: "0",
                              }}
                            >
                              https://tatclub.com/
                            </span>
                          </div>
                          <input
                            style={{
                              borderRadius: "0 10px 10px 0",
                            }}
                            type="text"
                            disabled={editDisable[0].status}
                            className={`form-control ${styles.inurl}`}
                            id="basic-url"
                            aria-describedby="basic-addon3"
                            value={SelectedUserInformation.urlPage}
                            onChange={(e) =>
                              setSelectedUserInformation({
                                ...SelectedUserInformation,
                                [e.target.name]: e.target.value,
                              })
                            }
                            name="urlPage"
                          />
                        </div>
                        {/* <input
                          disabled={editDisable[0].status}
                          className={styles.inpu}
                          type="text"
                          value={SelectedUserInformation.urlPage}
                          onChange={(e) =>
                            setSelectedUserInformation({
                              ...SelectedUserInformation,
                              [e.target.name]: e.target.value,
                            })
                          }
                          name="urlPage"
                        /> */}
                      </div>
                    </div>
                    <div
                      className={` col-lg-6 col-xs-12   text-center  ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}>اطلاعات تماس </p>
                        <div
                          className={`d-flex flex-column justify-content-between ${styles.wi}`}
                          style={{ height: "70px" }}
                        >
                          <input
                            disabled={editDisable[0].status}
                            className={styles.nimInput}
                            type="text"
                            value={SelectedUserInformation.num}
                            onChange={(e) =>
                              setSelectedUserInformation({
                                ...SelectedUserInformation,
                                [e.target.name]: e.target.value,
                              })
                            }
                            name="num"
                          />
                          <input
                            disabled={editDisable[0].status}
                            className={styles.nimInput}
                            type="text"
                            value={SelectedUserInformation.num2}
                            onChange={(e) =>
                              setSelectedUserInformation({
                                ...SelectedUserInformation,
                                [e.target.name]: e.target.value,
                              })
                            }
                            name="num2"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={` col-lg-6 col-xs-12    text-center  ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}>آدرس </p>
                        <input
                          className={styles.inpu}
                          type="text"
                          disabled={editDisable[0].status}
                          value={SelectedUserInformation.address}
                          onChange={(e) =>
                            setSelectedUserInformation({
                              ...SelectedUserInformation,
                              [e.target.name]: e.target.value,
                            })
                          }
                          name="address"
                        />
                      </div>
                    </div>
                    <div
                      className={` col-lg-6 col-xs-12    text-center 
                       ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}> درباره ما</p>
                        <input
                          disabled={editDisable[0].status}
                          className={styles.inpu}
                          type="text"
                          value={SelectedUserInformation.about}
                          onChange={(e) =>
                            setSelectedUserInformation({
                              ...SelectedUserInformation,
                              [e.target.name]: e.target.value,
                            })
                          }
                          name="about"
                        />
                      </div>
                    </div>
                    <div
                      className={` col-lg-6 col-xs-12   text-center  ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}>شبکه های اجتماعی</p>
                        <div
                          className={`d-flex flex-column justify-content-between ${styles.wi}`}
                          style={{ height: "70px" }}
                        >
                          {SelectedUserInformation.socialMedia.map(
                            (socialMedia, index) => (
                              <div
                                key={index}
                                className="d-flex w-100 flex-column justify-content-between  mt-2"
                              >
                                <div className="w-100 d-flex ">
                                  <input
                                    className={`w-100 text-end rounded ${styles.nimInput}`}
                                    value={socialMedia.nameField}
                                    disabled={editDisable[0].status}
                                    onChange={(event) =>
                                      handleChangeInput(index, event)
                                    }
                                    name="nameField"
                                  />

                                  <select
                                    disabled={editDisable[0].status}
                                    className={`form-select form-select-sm inputBoxSelect bg-light text-center ${styles.nimInput5}`}
                                    aria-label="Default select example"
                                    value={socialMedia.selectField}
                                    onChange={(event) =>
                                      handleChangeInput(index, event)
                                    }
                                    name="selectField"
                                  >
                                    <option selected hidden disabled value="-1">
                                      انتخاب کنید{" "}
                                    </option>
                                    <option value="1">instagram </option>
                                    <option value="2"> telegram</option>
                                    <option value="3"> whatsApp</option>
                                  </select>
                                  <div
                                    className="d-flex justify-content-evenly align-items-center "
                                    style={{
                                      width: "100px",
                                      fontSize: "20px",
                                      color: "#333",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <MdAddCircleOutline
                                      onClick={handleAddFields}
                                    />
                                    {index != 0 && (
                                      <MdRemoveCircleOutline
                                        onClick={() =>
                                          handleRemoveFields(index)
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={` col-lg-6 col-xs-12    text-center  ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}> کاور فروشگاه</p>
                        <input
                          type="file"
                          ref={inputRef}
                          onChange={changeHandlerImg}
                          className={`form-control input-color ${styles.inputt} `}
                          id="profile-pic"
                          name="cover"
                          disabled={editDisable[0].status}
                          style={{ lineHeight: "4.5rem", padding: "0 10px" }}
                        />
                      </div>
                    </div>

                    {/* <div
                      className={` col-lg-6 col-xs-12   text-center  ${styles.cardP}`}
                    >
                      <div className={styles.flexbless}>
                        <p className={styles.pStyle}>برچسب ها</p>
                        <CreatableSelect
                          isDisabled={editDisable[0].status}
                          className={styles.inpuSlect}
                          value={value}
                          onChange={changeHandlerDaste}
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          ixsulti
                          options={optionDasteBandi}
                        />
                      </div>
                    </div> */}
                  </div>
                  <div className={` ${styles.btnsty}`}>
                    {editDisable[0].status ? (
                      <button
                        onClick={editHandler}
                        className="btn px-5 mx-3 mt-4 bg-success text-light"
                      >
                        {" "}
                        ویرایش
                      </button>
                    ) : (
                      <button
                        onClick={() => updateHandler(SelectedUserInformation)}
                        className="btn mx-3 mt-4 bg-success px-5 text-light"
                      >
                        {" "}
                        ثبت
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="contact"
              role="tabpanel"
              aria-labelledby="contact-tab"
            >
              <div className=" w-100 mt-3 ">
                <div className="container">
                  <CustomerManagement />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
